module.exports = __webpack_public_path__ + "static/media/simplification.bfd46a1a.jpg";